import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const compensationSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardStatus: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARD_STATUS,
                    params: { year, month, scorecardVersionId },
                };
            },
            // keepUnusedDataFor: 0,
            providesTags: ['Approvals'],
        }),
        getPrimaryApprovalWindow: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId, approvalWindowConfigLevelId } = arg;
                return {
                    url: constants.PRIMARY_APPROVAL_WINDOW,
                    params: { year, month, scorecardVersionId, approvalWindowConfigLevelId },
                };
            },
            // keepUnusedDataFor: 0,
            providesTags: ['Approvals', 'HaltApprovals'],
        }),
        getScorecardApprovePCTSearch: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARD_APPROVE_PCT_SEARCH,
                    params: { year, month, scorecardVersionId },
                };
            },
            // keepUnusedDataFor: 0,
            providesTags: ['Approvals'],
        }),

        getSorecardRoles: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId, applicationRoleId } = arg;
                return {
                    url: constants.SCORECARD_ROLES,
                    params: { year, month, scorecardVersionId, applicationRoleId },
                };
            },
            providesTags: ['Approvals'],
        }),
        getPayoutExtractGrid: builder.query({
            query: (arg: any) => {
                const { year, month } = arg;
                return {
                    url: constants.PAYOUT_EXTRACT_HISTORY,
                    params: { year, month },
                };
            },           
            providesTags: ['Approvals'],
        }),
        getPayoutExtractExport: builder.query({
            query: (arg: any) => {
                const { payoutExtractId } = arg;
                return {
                    url: constants.PAYOUT_EXTRACT_DETAILS,
                    params: {payoutExtractId },
                };
            },
            
            providesTags: ['Approvals'],
        }),
        updateInsertScorecardApprovalWindow: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_INSERT_SCORECARD_APPROVAL_WINDOW,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),
        updateApprovalWindowOverride: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_APPROVAL_WINDOW_OVERRIDE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),
        updatePayoutExtractStatus: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_PAYOUT_EXTRACT_STATUS,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),
        updateCertifiedScorecardApprovalWindow : builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_CERTIFIED_SCORECARD_APPROVAL_WINDOW,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),

        getApprovalWindowNotification: builder.query({
            query: (arg: any) => {
                const { employeeNumber, managerLevel } = arg;
                return {
                    url: constants.APPROVAL_WINDOW_NOTIFICATION,
                    params: {employeeNumber, managerLevel },
                };
            },
        }),
    }),
});

export const {
    useGetScorecardStatusQuery,
    useUpdateInsertScorecardApprovalWindowMutation,
    useUpdateApprovalWindowOverrideMutation,
    useGetPrimaryApprovalWindowQuery,
    useGetScorecardApprovePCTSearchQuery,
    useGetSorecardRolesQuery,
    useGetPayoutExtractGridQuery,
    useGetPayoutExtractExportQuery,
    useUpdatePayoutExtractStatusMutation,
    useUpdateCertifiedScorecardApprovalWindowMutation,
    useGetApprovalWindowNotificationQuery,
} = compensationSlice;
